export const PAYOUT_KIND = {
  PAYPAL: 'paypal',
  BANK_TRANSFER: 'bankTransfer',
  WISE: 'wise',
};

/**
 * @param {{ gateway?: string, transferMethod?: string } | null | undefined} method
 * @returns {'paypal' | 'bankTransfer' | 'wise' | null}
 */
export function getPayoutMethodKind(method) {
  if (!method) return null;
  if (method.gateway === 'PayPal') return PAYOUT_KIND.PAYPAL;
  const tm = method.transferMethod;
  if (tm != null && String(tm).trim() !== '') return PAYOUT_KIND.BANK_TRANSFER;
  if (method.gateway === 'Wise') return PAYOUT_KIND.WISE;
  if (method.gateway === 'AirWallex') return PAYOUT_KIND.BANK_TRANSFER;
  return PAYOUT_KIND.BANK_TRANSFER;
}

/**
 * @param {{ gateway?: string, transferMethod?: string } | null | undefined} method
 * @param {{ short?: boolean }} [options]
 */
export function getPayoutMethodDisplayName(method, { short = false } = {}) {
  const kind = getPayoutMethodKind(method);
  if (kind === PAYOUT_KIND.PAYPAL) return short ? 'PayPal' : 'Paypal Transfer';
  if (kind === PAYOUT_KIND.WISE) return short ? 'Wise' : 'Wise Transfer';
  return short ? 'Bank' : 'Bank Transfer';
}
